var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2499",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2503"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2513"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path2511"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2505",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2509",
    clipPath: "url(#clipPath2513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2515",
    transform: "translate(256,15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -60,90 -165,212 -165,317 0,90.981 74.019,165 165,165 90.981,0 165,-74.019 165,-165 C 165,212 60,90 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2517"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2519",
    transform: "translate(256,257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -41.353,0 -75,33.647 -75,75 0,41.353 33.647,75 75,75 41.353,0 75,-33.647 75,-75 C 75,33.647 41.353,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2521"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.dbf775d7a18ed8e85ddbe0ede3dbb02e.svg";
export { ForwardRef as ReactComponent };